module.exports = __webpack_public_path__ + "static/img/header-logo.37bf78c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newImage/header-logo.png
// module id = b6SD
// module chunks = 19